import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { doGetInvalidControlsList, doTouchAllFields, WrapperDynamicFormOptionDto, WrapperWorkflowElementDto } from '../../workflow-utils';
import { DynamicValueDataTypeEnum } from '../../../../../service/dto';
import { NzSelectOptionInterface } from 'ng-zorro-antd/select';

@Component({
	selector: 'app-workflow-form-element',
	standalone: false,
	templateUrl: './workflow-form-element.component.html',
	styleUrl: './workflow-form-element.component.scss'
})
export class WorkflowFormElementComponent implements OnInit {
	@Input() input!: WrapperWorkflowElementDto;
	statusOptions: NzSelectOptionInterface[] = [];
	dataTypes: DynamicValueDataTypeEnum[] = ['Text', 'TextArea', 'Boolean', 'DropDownSingle', 'Number', 'PastDate', 'FutureDate', 'Date', 'Time', 'PastDateTime', 'FutureDateTime', 'File', 'Password', 'Email', 'Msisdn', 'RequiredCheckbox'];

	constructor(private fb: FormBuilder, private modalRef: NzModalRef) {
	}
	ngOnInit() {
		console.log("Input", this.input);
		this.statusOptions = this.input.parent.parent.statuses.map(status => ({
			label: status._label ?? 'No Label',
			value: status.payload.id
		}));
	}

	get hasDependency(): boolean {
		return this.input.formGroup.get('dependencyId')!.value != undefined;
	}
	getAllElements(): WrapperWorkflowElementDto[] {
		return this.input.parent.parent.sections.map(item => item.elements).flat().filter(item => item.payload.id != this.input.payload.id);
	}

	getOptions(): AbstractControl[] {
		return (this.input._options as FormArray).controls;
	}
	addOption(): void {
		WrapperDynamicFormOptionDto.add(this.fb, this.input);

	}

	removeOption(index: number): void {
		WrapperDynamicFormOptionDto.remove(this.input, index);
	}





	doClose() {
		this.modalRef.close({ action: 'cancel' });
	}
	doTouchAllFields(group: FormGroup | FormArray = this.input.formGroup) {
		Object.values(group.controls).forEach(control => {
			if (control instanceof FormControl) {
				control.markAsDirty({ onlySelf: true });
				control.updateValueAndValidity({ onlySelf: true });
			} else if (control instanceof FormGroup || control instanceof FormArray) {
				this.doTouchAllFields(control);
			}
		});
	}
	doDelete() {
		console.log('Closing modal');
		this.modalRef.close({ action: 'delete', value: this.input });
	}
	compareSelectValues = (o1: any, o2: any): boolean => o1 && o2 ? o1.id === o2.id : o1 === o2;







	touchAllFields() {
		doTouchAllFields(this.input.formGroup);
	}
	getInvalidControlsList() {
		return doGetInvalidControlsList(this.input.formGroup);
	}
}
